import axios from 'axios'

const state = {
  users: [],
  roles: [],
  emailFail: false,
  tokenFail: false
}

const getters = {}

const mutations = {
  setUsers (state, users) {
    state.users = users
  },
  setUser (state, user) {
    state.user = user
  },
  updateUser(state, payload){
    const index = state.users.findIndex(item => item.id === payload.id);
    var roles = payload.roles.map(role => {
      return state.roles.find(r => r.id === role)
    })
    roles = roles.map(r => {
      return r.name
    })
    payload.roles = roles
    if (index !== -1) state.users.splice(index, 1, payload);
    console.log(state.users)
  },
  setEmailFail (state, bool) {
    state.emailFail = bool
  },
  setTokenFail (state, bool) {
    state.tokenFail = bool
  },
  setRoles(state, payload){
    state.roles = payload
  },
  deleteUser(state, id){
    var index = state.users.findIndex(user => user.id == id)
    state.users.splice(index, 1)
  }
}

const actions = {
  
  getUsersList (context) {
    return axios.get('/api/users')
      .then(response => { context.commit('setUsers', response.data);
    })
      .catch(e => { console.log(e) })
  },
  getRolesList(context){
    return axios.get('/api/users/roles/')
    .then(response => { context.commit('setRoles', response.data); })
    .catch(e => { console.log(e) })
  },
  getUser (context, userId) {
    return axios.get('/api/users/' + userId)
      .then(response => { context.commit('setUser', response.data) })
      .catch(e => { console.log(e) })
  },
  createUser (context, payload) {
    return axios.post('/api/users/', payload)
  },
  editUser (context, payload) {
    return axios.patch('/api/users/' + payload.id + '/', payload)
    .then(response => { 
      let data = {...response.data}
      data.id = payload.id
      context.commit('updateUser', data) })
    .catch(e => { console.log(e) })
  },
  deleteUser (context, userId) {
    return axios.delete('/api/users/' + userId)
      .then(response => {
        context.commit('deleteUser', userId)
      })
      .catch(e => {  })
  },
  passwordReset (context, user) {
    return axios.post('/api/users/password_reset/', user)
      .then(response => { context.commit('setEmailFail', false) })
      .catch(e => { context.commit('setEmailFail', true) })
  },
  passwordChange (context, payload) {
    return axios.post('/api/users/password_change/', payload)
      .then(response => { context.commit('setTokenFail', false) })
      .catch(e => { context.commit('setTokenFail', true) })
  }
  
}

export default {
  state,
  getters,
  mutations,
  actions
}
